import { Body, Spacer } from '@spritz-finance/ui'
import styled from 'styled-components'
import { isQuickswap } from '../../../theme/utils'

const Wrapper = styled.div`
    background: var(--surface-2);
    border-radius: 10px;
    padding: 16px;
`

const Link = styled(Body.Bold)`
    text-decoration: underline;
    &:hover {
        cursor: pointer;
    }
`
export const QuickswapSignUpBanner = () => {
    const quickswap = isQuickswap()

    if (!quickswap) return null

    return (
        <>
            <Wrapper>
                <Body.Med size={14}>
                    Spritz is currently available to QuickSwap users who live in the US.{' '}
                    <Link
                        onClick={() => {
                            window.open('https://www.spritz.finance/waitlist-rank')
                        }}
                        size={14}
                        color="#448AFF"
                    >
                        Join the waitlist
                    </Link>{' '}
                    to be first to know when Spritz becomes available in your country.
                </Body.Med>
            </Wrapper>
            <Spacer height={16} />
        </>
    )
}
